import { WidgetConfigWithHideableToolbar } from 'widgets/WidgetToolbarShowHidePanel/WidgetConfigWithHideableToolbar';
import { ConfigStateWithGridSupport } from 'widgets/store/grid/reducer.ts';
import { OrderVolumeProfileGridColumn } from 'widgets/orderVolumeProfile/components/grid/columns.tsx';
import { SortDirection } from '@instinet-analytics/core-lib';

export interface OrderVolumeProfileConfiguration
    extends WidgetConfigWithHideableToolbar,
        ConfigStateWithGridSupport<OrderVolumeProfileGridColumn> {
    barSizeInMinutes: number;
    includeAuctions: boolean;
    regular: boolean;
    custom: boolean;
}

export const initialOrderVolumeProfileConfiguration: OrderVolumeProfileConfiguration =
    {
        barSizeInMinutes: 10,
        includeAuctions: true,
        regular: true,
        custom: false,
        visibleColumns: [
            'startTime',
            'endTime',
            'vol',
            'auctVol',
            'contVol',
            'cumVol',
            'wgt',
            'auctWgt',
            'contWgt',
            'cumWgt',
        ],
        columnWidths: {},
        sort: [{ colId: 'startTime', sort: SortDirection.ASCENDING }],
    };
